<div mat-dialog-content class="dialog-content text-center">
  <div class="icon-wrapper">
    <mat-icon class="delete-icon">block</mat-icon>
  </div>

  <h2 class="dialog-title pt-3 font-name">Disable this link?</h2>
  <p class="dialog-message pt-1 font-name">
    Candidates will no longer be able to access the assessment via this link.
    You can re-enable it later.
  </p>

  <div mat-dialog-actions align="center" class="dialog-actions">
    <button class="btn btn-color font-name" (click)="closeDialog()">
      Cancel
    </button>
    <button class="btn btn-danger ms-3 font-name" (click)="confirm()">
      Yes , disable
    </button>
  </div>
</div>
